module.exports = __webpack_public_path__ + "static/media/puddle_jumper_octodex.909dfe2b.jpg";